module.exports = __webpack_public_path__ + "static/media/teal-arrow.fdfb38dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guestlist/teal-arrow.svg
// module id = 2372
// module chunks = 71